import React, { Fragment, useEffect, useState } from 'react';
import { useMedia } from 'react-use';
import { Dialog, Transition } from '@headlessui/react';
import { SbCurrentUser } from './SbModel';
import { CircleXIcon, XIcon } from 'lucide-react';
import { KitCategories, KitDocumentModel, MediaKitModel, MediaKitSettingModel } from '../../submission_kits/components/KitModels';
import CustomUppyUploaderv2 from '../../submission_kits/components/CustomUppyUploaderv2';
import kitDocumentService from '../../services/KitDocumentService';
import mediaKitService from '../../services/MediaKitService';
import { showToast } from '../../shared/Toast';

export interface MediaUploadModalProps {
  currentUser: SbCurrentUser;
  fromScreen: string;
  filetype: number;
  dialogCloseHandler: () => void;
  fetchMediaKitHandler: () =>  Promise<void>;
}


export default function MediaUploadModal({
  currentUser,
  fromScreen,
  filetype,
  dialogCloseHandler,
  fetchMediaKitHandler,
}: MediaUploadModalProps) {
  const MaxImageSizeMb: number = 30;
  const MaxVideoSizeMb: number = 1*1024*11;

  // const [mediaKitDocumentsSelected, setMediaKitDocumentsSelected] = useState<KitDocumentModel[]>(
  //   []
  // );
  // const [submissionKitDocumentsSelected, setSubmissionKitDocumentsSelected] = useState<
  //   SubmissionKitDocumentModel[]
  // >([]);
  const [mediaKit, setMediaKit] = useState<MediaKitModel>();
  const [mediaKitDocuments, setMediaKitDocuments] = useState<KitDocumentModel[]>([]);
  const [mediaSetting, setMediaSetting] = useState<MediaKitSettingModel>({
    imageCount: -1,
    videoCount: -1,
    imageAllowed: 0,
    videoAllowed: 0,
  });

  const [showDialog, setShowDialog] = useState(true);
  const [isUploadedMedia, setIsUploadedMedia] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState('');

  const isMobileScreen = useMedia('(max-width: 1024px)', false);

  useEffect(() => {
    fetchMediaKits(1, true, false);
  }, []);

  const fetchMediaKits = async (
    pageParam: number,
    doMediaSetting: boolean,
    doFlagSetting: boolean
  ) => {
    try {
      // if (noMoreData.length > 0 && pageParam != 0) {
      //   console.log('fetchSubmissionBoards no more data is set');
      //   return;
      // }
      // setIsLoading(true);
      console.log('sb: fetchMediaKits In');
      if (mediaKitDocuments && mediaKitDocuments.length <= 0) {
        pageParam = 1;
      }
      let filter = '';
      const responseData = await mediaKitService.fetchMediaKits(filter, '', pageParam, 999999);
      if (responseData) {
        if (doMediaSetting) {
          let mediasetting: MediaKitSettingModel = { ...mediaSetting };
          if (responseData.image_count != undefined) {
            mediasetting.imageCount = responseData.image_count;
          }
          if (responseData.video_count != undefined) {
            mediasetting.videoCount = responseData.video_count;
          }
          if (responseData.allowed_image != undefined) {
            mediasetting.imageAllowed = responseData.allowed_image;
          }
          if (responseData.allowed_video != undefined) {
            mediasetting.videoAllowed = responseData.allowed_video;
          }
          setMediaSetting(mediasetting);
        }
        if (responseData.media_kit) {
          setMediaKit(responseData.media_kit);
        }
        if (responseData.kit_documents.length > 0) {
          setMediaKitDocuments(responseData.kit_documents);
          // if (responseData.kit_documents.length == perPage) {
          //   console.log('sb: fetchMediaKits page:', page);
          //   setPage((prev) => prev + 1);
          //   setNoMoreData('');
          // } else {
          //   setNoMoreData('No more media...');
          // }
          // If page 1 or mediaKitDocuments is null/empty, replace instead of append
          // if (pageParam === 1 || !mediaKitDocuments || mediaKitDocuments.length === 0) {
          //   if (doFlagSetting) {
          //     setFlags(responseData.kit_documents);
          //   }
          //   setMediaKitDocuments(responseData.kit_documents);
          // } else {
          //   setMediaKitDocuments((prevRecords) => {
          //     let kitDocs = [...prevRecords, ...responseData.kit_documents];
          //     setFlags(kitDocs);
          //     return kitDocs;
          //   });
          // }
        } else {
          setMediaKitDocuments([]);
          // if (pageParam === 1) {
          //   setMediaKitDocumentsImagePresent(false);
          //   setMediaKitDocumentsVideoPresent(false);
          //   setshowUploadMediaImage(true);
          //   setshowUploadMediaVideo(true);
          //   setMediaKitDocuments([]);
          // }
          // setNoMoreData('No more media...');
        }
        return;
      }
      // if (mediaKitDocuments && mediaKitDocuments.length <= 0 && pageParam == 1) {
      //   setNoMoreData('No more media...');
      // }
    } catch (error) {
      showToast('Error while fetching submission kits.', 'danger');
    } finally {
      console.log('sb: fetchMediaKits Out');
      console.log('sb: isLoading false');
      // setIsLoading(false);
    }
  };

  const onCloseDialog = () => {
    dialogCloseHandler();
    setShowDialog(false);
  };
  // Escape close popup start
  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && showDialog) {
        onCloseDialog();
      }
    };
    window.addEventListener('keydown', handleEscKey);
    return () => {
      window.removeEventListener('keydown', handleEscKey);
    };
  }, [onCloseDialog]);
  // Escape close popup end

  return (
    <Transition.Root show={showDialog} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          onCloseDialog();
        }}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-customGray" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center m-6 text-left">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="relative flex flex-col w-full max-w-4xl rotate-0 opacity-100 border border-solid border-gray-300 bg-white py-1 rounded-md shadow-xl-0-19-40-8">
                {/* Header */}
                <div className="flex items-center justify-between px-4 sm:px-6 py-4">
                  {!(mediaKitDocuments.length <= 0) && (
                    <div className="flex flex-row font-semibold text-lg sm:text-xl">Upload Media</div>
                  )}
                  <button
                    type="button"
                    className="flex h-8 w-8 items-center justify-center rounded-md hover:bg-gray-100"
                    onClick={() => {
                      onCloseDialog();
                    }}
                  >
                    <span className="sr-only">Close menu</span>
                    <XIcon className="h-6 w-6 text-gray-400" aria-hidden="true" />
                  </button>
                </div>
                <div className="w-full flex flex-row items-start justify-center">
                  <div className="bg-white w-full flex flex-col overflow-auto gap-6">
                    <>
                      <div className="flex flex-col px-4 sm:px-8 pt-5 pb-8 gap-2-1">
                        {/* MODAL */}
                        {errorMessage.length > 0 && (
                          <div className="flex flex-row px-2-1 py-2-1 gap-2 relative rounded-md bg-red-701 border-red-450 border">
                            <CircleXIcon className="w-6 h-6" />
                            <div className="font-medium font-xs">{errorMessage}</div>
                          </div>
                        )}

                        {mediaSetting.imageCount >= 0 && (
                          <CustomUppyUploaderv2
                            isReplaced={false}
                            backendUrl={'/'}
                            mediaType={filetype}
                            maxFileSizeMb={filetype == 1 ? MaxImageSizeMb : MaxVideoSizeMb}
                            mediaSetting={mediaSetting}
                            maxUploadFiles={1}
                            handleCloseUploader={async () => {
                              // setshowReplaceModal(false);
                              // setMediaKitDocumentSelected(null);
                              // setshowUploadMediaImage(false);
                              // setshowUploadMediaVideo(false);
                              if (isUploadedMedia) {
                                setIsUploadedMedia(false);
                                await fetchMediaKitHandler();
                              }
                              onCloseDialog();
                            }}
                            filesUploaded={async (fileUppy: any) => {
                              console.log('filesUploaded s');
                              await kitDocumentService.createKitDocument(
                                fileUppy,
                                KitCategories.media_kit_cat,
                                mediaKit.uuid
                              );
                              console.log('filesUploaded e');
                            }}
                            handleErrorMessage={function (error: string): void {
                              setErrorMessage(error);
                            }}
                            uploadCompleted={async () => {
                              setIsUploadedMedia(true);
                            }}
                            validateSameFileName={function (filesUppy: any): string[] {
                              let sameFiles = [];
                              mediaKitDocuments.map((kit_document, index) => {
                                const files = filesUppy.filter((fileAdded) => {
                                  return (
                                    fileAdded.name.toLowerCase() ==
                                    kit_document.file_name.toLowerCase()
                                  );
                                });
                                if (files.length > 0) {
                                  sameFiles = sameFiles.concat(files.map((item) => item.name));
                                }
                              });
                              console.log('sameFiles:', sameFiles);
                              return sameFiles;
                            }}
                          />
                        )}
                      </div>
                    </>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}